import React from "react";

const BRAND_LOGO_URL = [
  "https://customer-assets-39nsmqrw.emergentagent.net/",
  "job_shift-tracker-430/artifacts/",
  "4hfe14cl_ChatGPT%20Image%20Sep%209%2C%202026%2C%2011_21_29%20AM.png",
].join("");

export default function BrandLogo({ className = "h-10 w-10", testId = "brand-logo" }) {
  return (
    <img
      src={BRAND_LOGO_URL}
      alt="Logo MLC Attendance"
      data-testid={testId}
      className={`shrink-0 object-contain ${className}`}
      decoding="async"
    />
  );
}